import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import aiimage from "../assets/images/ai_ml.jpg";
import iotimage from "../assets/images/iot.jpg";
import roboticsimage from "../assets/images/robotics.jpg";
import promptengineeringimage from "../assets/images/prompt_engineering.jpg";

function Courses() {
  const createSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };
  const navigate = useNavigate();

  const [filter, setFilter] = useState("all");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ IMAGE MAP
  const getImage = (img) => {
    switch (img) {
      case "ai_ml.jpg":
        return aiimage;
      case "iot.jpg":
        return iotimage;
      case "robotics.jpg":
        return roboticsimage;
      case "prompt_engineering.jpg":
        return promptengineeringimage;
      default:
        return aiimage;
    }
  };

  // ✅ FETCH COURSES
  useEffect(() => {
    fetch("https://swiftintelli.com/api/getCourses.php")
      .then(async (res) => {
        const text = await res.text();
        try {
          return JSON.parse(text);
        } catch {
          console.error("Invalid JSON:", text);
          return [];
        }
      })
      .then((data) => {
        setCourses(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  // ✅ FILTER
  const filtered =
    filter === "all" ? courses : courses.filter((c) => c.type === filter);

  // ✅ ANIMATION
  function useInView(ref) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      const obs = new IntersectionObserver(
        ([e]) => e.isIntersecting && setVisible(true),
        { threshold: 0.1 },
      );

      if (ref.current) obs.observe(ref.current);
      return () => obs.disconnect();
    }, [ref]);

    return visible;
  }

  function AnimCard({ className, children, delay = 0 }) {
    const ref = useRef(null);
    const visible = useInView(ref);

    return (
      <div
        ref={ref}
        className={`${className} ${visible ? "visible" : ""}`}
        style={visible ? { transitionDelay: `${delay}ms` } : {}}
      >
        {children}
      </div>
    );
  }
  return (
    <section id="courses" className="si-section si-courses">
      {/* HEADER */}
      <div className="si-courses-header">
        <div>
          <div className="si-section-label">Our Programs</div>
          <h2 className="si-h2">
            Courses <span style={{ color: "var(--accent)" }}>Offered</span>
          </h2>
        </div>

        <div className="si-tab-filters">
          {["all", "live", "upcoming"].map((f) => (
            <button
              key={f}
              className={`si-tab-btn ${filter === f ? "active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f === "live" ? "Live Now" : "Upcoming"}
            </button>
          ))}
        </div>
      </div>

      {/* LOADING */}
      {loading && <h3 style={{ textAlign: "center" }}>Loading...</h3>}

      {/* COURSES */}
      <div className="si-courses-grid">
        {!loading && courses.length === 0 && (
          <p style={{ textAlign: "center" }}>❌ No data from API</p>
        )}

        {filtered.map((c, i) => (
          <AnimCard key={c.id} className="si-course-card" delay={i * 80}>
            <div className="si-course-thumb">
              <img
                src={
                  c.image
                    ? `https://swiftintelli.com/api/uploads/${c.image}`
                    : getImage(c.image)
                }
                alt={c.title}
              />
              <span className={`si-course-badge ${c.type}`}>
                {c.type === "live" ? "ONGOING" : "COMING SOON"}
              </span>
            </div>

            <div className="si-course-body">
              <div className="si-course-cat">{c.category}</div>
              <div className="si-course-name">{c.name}</div>
              <div className="si-course-desc">{c.description}</div>

              <div className="si-course-footer">
                <div>⏱ {c.duration}</div>

                {c.type === "live" ? (
                  <button
                    className="si-enroll-btn"
                    onClick={() => navigate(`/course/${c.slug}`)}
                  >
                    Enroll Now →
                  </button>
                ) : (
                  <button
                    className="si-enroll-btn outline"
                    onClick={() => {
                      const el = document.getElementById("contact");
                      if (el) el.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Notify Me
                  </button>
                )}
              </div>
            </div>
          </AnimCard>
        ))}
      </div>

      <div className="si-upcoming-banner">
        <div className="si-upcoming-icon">🔔</div>
        <div className="si-upcoming-text">
          <h3>More courses are on the horizon</h3>
          <p>
            Cloud Architecture, Data Engineering, and Cybersecurity are in
            development. Stay tuned.
          </p>
        </div>
        <div className="si-upcoming-action">
          <Link
            to="/contact"
            className="si-btn-primary"
            style={{ fontSize: 14, padding: "11px 24px" }}
          >
            Stay Updated
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Courses;
